import React from 'react';
import PropTypes from 'prop-types';

export const AirlinesRowHeader = ({ checkInArea, code, tailLogo, name }) => (
  <div className="list__item__summary-wrapper airline__info-header">
    <div className="airline__tail-logo-wrapper">
      {tailLogo.length > 0 && (
        <img
          src={tailLogo}
          alt={`${name} tail logo`}
          className="airline__tail-logo"
        />
      )}
    </div>
    <div className="airline__airline-name">{name}</div>
    <div className="airline__code">{code}</div>
    <div className="airline__check-in">{checkInArea}</div>
    <div className="list__item__collapse" />
  </div>
);

AirlinesRowHeader.defaultProps = {
  tailLogo: '',
};

AirlinesRowHeader.propTypes = {
  advanceCheckIn: PropTypes.string.isRequired,
  checkInArea: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  tailLogo: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default AirlinesRowHeader;
